import { C2SUploadArtifacts } from "./UploadConfigurationStep";

export type C2SFieldName = "ArtifactFiles";

export const c2sFileMap: Record<C2SFieldName, Array<{ id: keyof C2SUploadArtifacts; title: string; file: string }>> = {
  ArtifactFiles: [
    {
      id: "layersConfiguration",
      title: "Layers Configuration",
      file: "layers_configuration.json",
    },
    {
      id: "bom",
      title: "Bill of Materials",
      file: "bom.csv",
    },
    {
      id: "costBreakdown",
      title: "Cost Breakdown",
      file: "cost_breakdown.csv",
    },
  ],
};
